/**
 * =============================================================================
 * Mandanten-Textschicht für die Startseite (a-045)
 * =============================================================================
 * Quelle: tenant_settings, setting_key = 'storefront_texts', json_config = {...}.
 * functions/api/tenant/resolve.js liefert tenant_settings bereits als
 * tenant.settings aus -> kein zusätzlicher Request, keine neue Tabelle.
 *
 * Fallback: fehlt der Eintrag (oder ist er leer), zeigt der Shop die
 * bisherige Master-Startseite. Bestehende Deployments ändern sich nicht.
 */

export const STOREFRONT_TEXT_KEYS = [
  'hero_title',
  'hero_subtitle',
  'trust_line',
  'section_title',
  'section_subtitle',
  'cta_title',
  'cta_text',
  'cta_button',
];

/**
 * Liefert die Texte des Mandanten als Objekt (nur nicht-leere Schlüssel),
 * oder null, wenn der Mandant keine eigenen Startseiten-Texte hat.
 */
export function getStorefrontTexts(tenant) {
  const raw = tenant?.settings?.storefront_texts;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const texts = {};
  for (const key of STOREFRONT_TEXT_KEYS) {
    const value = raw[key];
    if (typeof value === 'string' && value.trim()) texts[key] = value.trim();
  }
  return Object.keys(texts).length > 0 ? texts : null;
}

/** true, wenn die B2C-/Mandanten-Startseite statt der Master-Startseite gezeigt wird. */
export function hasStorefrontTexts(tenant) {
  return getStorefrontTexts(tenant) !== null;
}

/**
 * Topbar-Texte (a-045 Nachzug): eigene Schlüssel im selben storefront_texts-Objekt.
 * Bewusst NICHT in STOREFRONT_TEXT_KEYS, damit ein reiner Topbar-Eintrag die
 * Startseiten-Weiche nicht aktiviert.
 */
export const TOPBAR_TEXT_KEYS = ['topbar_badge', 'topbar_shipping'];

export const TOPBAR_FALLBACKS = {
  topbar_badge: 'Ihr Fachbetrieb für Sicherheitstechnik',
  topbar_shipping: 'Persönliche Beratung · Fachhandel · Montage-Service',
};

/** Liefert Topbar-Texte inkl. Master-Fallback je Schlüssel. */
export function getTopbarTexts(tenant) {
  const raw = tenant?.settings?.storefront_texts;
  const result = { ...TOPBAR_FALLBACKS };
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return result;
  for (const key of TOPBAR_TEXT_KEYS) {
    const value = raw[key];
    if (typeof value === 'string' && value.trim()) result[key] = value.trim();
  }
  return result;
}
